/**
 * CSR (control) entry for the landing welcome route. Mounted under
 * the global `<RootRuntime>` `<ApolloClientProvider>` /
 * `<QueryClientProvider>` via `dynamicWithExperiment` in
 * `routes/landing.welcome._index.tsx`.
 *
 * `LandingHome` already isolates the heavy client-only sections
 * (`ExperienceSection`, `GrowthElements`, `PricingSection` Apollo
 * data) inside `<ClientOnly>` boundaries, so it renders cleanly
 * under the global Apollo client. `initialPaymentItems` is left
 * `undefined`; the live `useLandingPricing` flow will fetch real
 * prices on hydrate (showing `PaidPlanCardFallback` until the
 * Apollo query lands) — equivalent to Stage 1 behaviour.
 */
import LandingHome from 'src/features/Landing/Welcome/components/LandingHome'

export default function LandingWelcomeCsrEntry() {
  return <LandingHome />
}
